import CustomHttpClient from '../customHttpClient';

import { getError, getUserInfo } from '../../utils';

import { GetVendorsFilter, GetVendorsListServiceResponse } from '../../interfaces/get-vendors-service';
import { VendorType } from '../../interfaces/enums/vendor-values-enum';


const customHttpClient = CustomHttpClient({
  baseUrl: 'maestros',
  scope: 'Maestros',
});

export const filterVendors = (
  proveedores: any[],
  filters: GetVendorsFilter
) => {
  try {
    return proveedores.filter(p => {
    const matchName =
      !filters.name ||
      p.nombre?.toLowerCase().includes(filters.name.toLowerCase());

    const matchType =
      !filters.vendorType ||
      filters.vendorType === VendorType.TODOS ||
      p.tipoProveedor === filters.vendorType;

    return matchName && matchType;
  });
  } catch (error) {
     throw new Error(getError(error));
  }
  
};


const VendorsService = {
  async getVendors(
      filters: GetVendorsFilter
    ): Promise<GetVendorsListServiceResponse> {
      const url = 'listaProveedoresRyC';
      const UserInfo = { ...getUserInfo() };
      const params = {
        empresa: UserInfo.empresa,
        sucursal: UserInfo.sucursal,
        tipo: filters.vendorType
      }
      try {
          const response = await customHttpClient.get(url, { params});
          let responseData = response.data;
          responseData.proveedores = filterVendors(responseData.proveedores, filters);  
          return responseData;
  
      } catch (error) {
        throw new Error(getError(error));
      }
    },
};

export default VendorsService;
